module.exports = __webpack_public_path__ + "img/type-underline.dce42049.svg";